/**
 * Scope-related update_self_config keys. Keep agentSelfConfigScopeFields.json in sync with
 * shared/w86-shared-lib/src/main/resources/agent-self-config-scope-fields.json
 * (enforced by agentSelfConfigScopeFields.test.js).
 */
import manifest from "./agentSelfConfigScopeFields.json";

export const SELF_CONFIG_SCOPE_FIELDS = Object.freeze([...manifest.fields]);

export const SELF_CONFIG_SCOPE_LIST_FIELDS = Object.freeze([...manifest.listFields]);

export const SELF_CONFIG_SCOPE_MODE_LABELS = Object.freeze({ ...manifest.modeFields });

export function isSelfConfigScopeField(key) {
  return SELF_CONFIG_SCOPE_FIELDS.includes(key);
}
